import {OnInit} from '@angular/core';

export enum ChartTypes {
  LINE = 'LineChart',
  STACKED_AREA = 'StackedAreaChart',
  AREA = 'AreaChart',
  PIE = 'PieChart',
  COLUMN = 'ColumnChart',
  PERCENT_AREA = 'PercentAreaChart',
  STACKED_COLUMN = 'StackedColumnChart',
}

class BasicChart {
  series: Array<{}>;
  title;
  xAxis = {};
  yAxis = [{title: null}, {opposite: true, title: null}];
  chart;
  tooltip = {formatter: null};
  time = {
    timezoneOffset: new Date().getTimezoneOffset(),
  };
  credits = {
    enabled: false,
  };

  setLabels(data) {
    this.xAxis['categories'] = data.labels;
  }

  constructor(data, title, type) {
    this.title = {text: title};
    this.series = data.dataSets;
    this.chart = {type};
  }
}

class LineChart extends BasicChart {
  xAxis = {
    type: 'datetime',
    labels: {
      rotation: -45,
      format: '{value:%e.%b.%Y}',
    },
  };

  constructor(data, title) {
    super(data, title, 'line');

    const yAxis = data.dataSets.findIndex(set => set.yAxis && set.yAxis !== 0);
    if (yAxis !== -1) {
      this.yAxis[1].title = {text: data.dataSets[yAxis].name};
    }
  }
}

class StackedAreaChart extends BasicChart {
  plotOptions = {
    area: {
      stacking: 'normal',
      lineColor: '#666666',
      lineWidth: 1,
      marker: {
        lineWidth: 1,
        lineColor: '#666666',
      },
    },
  };
  xAxis = {
    type: 'datetime',
    labels: {
      rotation: -45,
      format: '{value:%e.%b.%Y}',
    },
  };

  constructor(data, title) {
    super(data, title, 'area');
  }
}

class PercentAreaChart extends BasicChart {
  plotOptions: {
    area: {
      stacking: 'percent';
      lineColor: '#ffffff';
      lineWidth: 1;
      marker: {
        lineWidth: 1;
        lineColor: '#ffffff';
      };
    };
  };

  xAxis = {
    type: 'datetime',
    labels: {
      rotation: -45,
      format: '{value:%e.%b.%Y}',
    },
  };

  constructor(data, title) {
    super(data, title, 'area');
  }
}

class AreaChart extends BasicChart {
  constructor(data, title) {
    super(data, title, 'area');
  }
}

class PieChart extends BasicChart {
  plotOptions = {
    pie: {
      allowPointSelect: true,
      cursor: 'pointer',
      dataLabels: {
        enabled: false,
      },
      showInLegend: false,
    },
  };

  chart = {
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: 'pie',
  };

  constructor(data, title) {
    super(data, title, 'pie');
    this.series = this.mapSeries(data);
  }

  mapSeries(data) {
    return [
      {
        colorByPoint: true,
        data: data.dataSets.map(stat => {
          return {
            name: stat.key,
            y: parseFloat(stat.values),
          };
        }),
      },
    ];
  }
}

class ColumnChart extends BasicChart {
  plotOptions: {
    column: {
      pointPadding: 0.2;
      borderWidth: 0;
    };
  };

  constructor(data, title) {
    super(data, title, 'column');
    this.series = data.dataSets.map(stat => {
      return {name: stat.key, data: stat.values};
    });
    this.setLabels(data);
  }
}

class StackedColumnChart extends BasicChart {
  plotOptions;

  constructor(data, title) {
    super(data, title, 'column');
    this.plotOptions = {
      column: {
        stacking: 'normal',
      },
    };
    this.setLabels(data);
  }
}

export const chartConstructors = {
  LineChart,
  StackedAreaChart,
  AreaChart,
  PieChart,
  ColumnChart,
  PercentAreaChart,
  StackedColumnChart,
};
